import { createAppAsyncThunk } from '../appAsyncThunk';
import { NotificationsResponse } from './types';
import { get } from 'aws-amplify/api';

export const getNotificationsThunk = createAppAsyncThunk(
    'notify/getNotificationsThunk', async () => {

        const restOperation = await get({
            apiName: 'emrNotify',
            path: '/emrNotify/{proxy+}',
        }).response;

        const response = await restOperation.body.json();
        return response as unknown as NotificationsResponse;
    });

/** The same endpoint marks a single notification as read once it receives its id. */
export const seenNotificationThunk = createAppAsyncThunk(
    'notify/seenNotificationThunk', async (notifyId: string) => {

        await get({
            apiName: 'emrNotify',
            path: '/emrNotify/{proxy+}',
            options: {
                queryParams: { notifyId }
            }
        }).response;

        return notifyId;
    });
